import { PLAN_COMPANY_LIMITS } from '../constants/config';
import type { Subscription } from '../context/CompanyContext';

/** True when subscription has a non-expired company-limit override. */
export function isOverrideActive(subscription: Subscription | null): boolean {
  if (!subscription?.limite_empresas_override) return false;
  if (!subscription.override_expires_at) return true;
  return new Date(subscription.override_expires_at).getTime() > Date.now();
}

/** True when subscription HAD a company-limit override that has now expired. */
export function isOverrideExpired(subscription: Subscription | null): boolean {
  if (!subscription?.limite_empresas_override) return false;
  if (!subscription.override_expires_at) return false;
  return new Date(subscription.override_expires_at).getTime() <= Date.now();
}

/**
 * Mapeo de planes legacy (subscriptions.plan histórico) a los nuevos
 * nombres de PLAN_COMPANY_LIMITS. 'trial' y 'starter' no necesitan mapeo:
 * ambos ya coinciden con una entrada de PLAN_COMPANY_LIMITS (trial: 1, starter: 5).
 */
export const LEGACY_PLAN_MAP: Record<string, string> = {
  professional: 'pro',
  business:     'firma',
};

/**
 * Base company limit for the subscription's plan.
 * null = sin límite: enterprise (null explícito en PLAN_COMPANY_LIMITS), o plan/subscription
 * desconocido — legacy accounts sin fila en `subscriptions` o con un plan que no está en
 * PLAN_COMPANY_LIMITS no se bloquean. Trial NO es "sin límite": PLAN_COMPANY_LIMITS.trial = 1.
 */
export function getPlanCompanyLimit(subscription: Subscription | null): number | null {
  if (!subscription?.plan) return null;
  const planKey = LEGACY_PLAN_MAP[subscription.plan] ?? subscription.plan;
  const limit = PLAN_COMPANY_LIMITS[planKey];
  return limit === undefined ? null : limit;
}

/**
 * Límite efectivo de empresas = override (si existe y no venció) > límite del plan.
 */
export function getEffectiveCompanyLimit(subscription: Subscription | null): number | null {
  if (isOverrideActive(subscription)) {
    return subscription!.limite_empresas_override;
  }
  return getPlanCompanyLimit(subscription);
}
